import { Loader2 } from "lucide-react";
import "./Loading.css";

const Loading = ({
  size = "medium",
  text = "Loading...",
  fullScreen = false,
  overlay = false,
}) => {
  const sizeClasses = {
    small: "loading-small",
    medium: "loading-medium",
    large: "loading-large",
  };

  const LoadingContent = () => (
    <div className={`loading-container ${sizeClasses[size]}`}>
      <div className="loading-spinner">
        <Loader2 className="spinner-icon" />
      </div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        <LoadingContent />
      </div>
    );
  }

  if (overlay) {
    return (
      <div className="loading-overlay">
        <LoadingContent />
      </div>
    );
  }

  return <LoadingContent />;
};

// Skeleton loading component for content placeholders
export const SkeletonLoader = ({
  lines = 3,
  height = "20px",
  className = "",
}) => {
  return (
    <div className={`skeleton-container ${className}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          className="skeleton-line"
          style={{
            height,
            width: index === lines - 1 ? "70%" : "100%",
          }}
        />
      ))}
    </div>
  );
};

// Card skeleton for loading cards
export const CardSkeleton = ({ className = "" }) => {
  return (
    <div className={`card-skeleton ${className}`}>
      <div className="skeleton-header">
        <div className="skeleton-avatar" />
        <div className="skeleton-title-group">
          <div className="skeleton-title" />
          <div className="skeleton-subtitle" />
        </div>
      </div>
      <div className="skeleton-content">
        <SkeletonLoader lines={3} />
      </div>
    </div>
  );
};

export default Loading;
